<template>
  <div class="dictionary">
    <div class="book" v-show="!showDictionary" @click="openDictionary()"></div>
    <div class="dictionary-swipper" v-if="showDictionary">
      <div class="dictionary-label"><p>SŁOWNICZEK <span>BANKOSŁOWEK</span></p></div>
      <div class="back-game" @click="closeDictionary()">< POWRÓT DO GRY</div>
      <div class="swipper-x">
        <div class="wrap">
          <div class="search">
            <input type="text" id="search" v-model="search" class="search-input" placeholder="SZUKAJ">
            <button type="submit" class="search-btn"></button>
          </div>
          <div class="swipper-inner">
            <swiper ref="dictionarySwiper" :options="swiperOptions" :auto-update="true" :auto-destroy="true">
              <swiper-slide v-for="card in filterCard">
                <img :src="require(`@/assets/images/dictionary_assets/${card.img}`)">
              </swiper-slide>
              <div class="swiper-button-prev" @click="slidePrev()" slot="button-prev"></div>
              <div class="swiper-button-next" @click="slideNext()" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {TimelineLite} from "gsap";
import {mapActions, mapGetters, mapMutations,} from 'vuex';
export default {
  name: "dictionary",
  data () {
    return {
      showDictionary: false,
      dictionaryCard:'',
      search:'',
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 20,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
    }
  },

  computed: {
    ...mapGetters(['hangmanGame']),
    swiper() {
      return this.$refs.mySwiper
    },
    filterCard : function (){
      // if (this.search.length > 1){
        return this.dictionaryCard.filter((card) => {
          const results = card.code.match(this.search.toUpperCase());
          return results
        });
      // }
    }
  },
  methods: {
    ...mapActions([ 'startGame', 'stopAudio']),
    openDictionary() {
      this.stopAudio();
      this.showDictionary = true
      this.$emit('stopTimer', true);
      this.$emit('isOpen', true);
      this.$gtm.push({
        event: 'ms-gameevent',
        category: "Misja samodzielność",
        action: "Kliknięcie w button - Słowniczek",
        label: "Pieniądze od podszewki: Gameplay",  //  gameType
      })
    },
    closeDictionary() {
      this.$emit('stopTimer', false);
      this.$emit('isOpen', false);
      this.showDictionary = false;
      let easy = new Howl({
        src: [require('@/assets/audio/bankoslowka/do_slowniczka/backToTheGame.mp3')]
      });
      easy.play();
    },
    slideNext(){
      this.$refs.dictionarySwiper.$swiper.slideNext()
    },
    slidePrev(){
      this.$refs.dictionarySwiper.$swiper.slidePrev()
    }
  },
  mounted() {
    this.dictionaryCard = this.hangmanGame.dataGame
    if (window.innerWidth < 800) {
      this.swiperOptions.slidesPerView = 1;
    }
  }
}
</script>
